export const env = {
    siteName: process.env.REACT_APP_SITE_NAME,
    founderName: process.env.REACT_APP_FOUNDER_NAME,
    supportPhone: process.env.REACT_APP_SUPPORT_PHONE_NUMBER,
    supportEmail: process.env.REACT_APP_SUPPORT_EMAIL,
    linkedinURL: process.env.REACT_APP_LINKEDIN_URL,
};